import { render } from "./CartWidget.vue?vue&type=template&id=a4d33e7e&scoped=true"
import script from "./CartWidget.vue?vue&type=script&lang=ts"
export * from "./CartWidget.vue?vue&type=script&lang=ts"

import "./CartWidget.vue?vue&type=style&index=0&id=a4d33e7e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a4d33e7e"

export default script